import { cn } from "utils/commonUtils";
import React from "react";

const TitleHeaderPage = ({
    className = "",
    text = "Some thing",
}) => {
    return (
        <div class={cn(`tw-px-0 tw-my-4 sm:tw-my-4`, className)}>
            <h1 class="tw-text-xl tw-font-semibold tw-text-gray-800 tw-capitalize -lg:tw-text-3xl">{text}</h1>
        </div>
    );
};

export default TitleHeaderPage;
